import ReadOnlyTextEditor from '../../../../../../components/TextEditor/ReadOnlyTextEditor';

const GroupReferenceQuestion = ({ question }) => {
  return (
    <>
      <ReadOnlyTextEditor content={question?.content || ''} />
    </>
  );
};

export default GroupReferenceQuestion;
